// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */

import { useEffect, useState } from 'react';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { animateScroll as scroll } from 'react-scroll';
import { NAVIGATION_TOP_OFFSET } from './components/Navigation';
import {
  Events,
  scrollSpy,
} from 'react-scroll';

import { actionCreatorsList } from '../../redux/rootActionCreator';
import { CreditMethod, LabInformation, RunningLab } from '../../types/Model';
import { useUpdateEffect } from '../../lib/utility';
import axios from 'axios';

const {
  sendVisitedLabActions,
  getLabInformationActions,
  buyLabActions,
  endLabActions,
  updateRunningLabAction,
} = actionCreatorsList;

export function useLoadLabScroll(markdowns: string[]): void {
  useEffect(() => {
    const item = localStorage.getItem('labScrollY');
    if (item !== null && markdowns.length > 0) {
      const scrollY = JSON.parse(item);
      scroll.scrollTo(scrollY, { delay: 1000, offset: NAVIGATION_TOP_OFFSET });
    }
  }, [markdowns]);
}

export function useSaveLabScroll(markdowns: string[]): void {
  useEffect(() => {
    function handleScrollEvent() {
      if (markdowns.length > 0) {
        localStorage.setItem('labScrollY', JSON.stringify(window.scrollY));
      }
    }

    window.addEventListener('scroll', handleScrollEvent);

    return () => {
      window.removeEventListener('scroll', handleScrollEvent);
    };
  }, [markdowns]);
}

export function parseMarkdown(markdown: string): string[] {
  const parsed:string[] = markdown
    .split('\n## ')
    .slice(1)
    .map(s => '## ' + s)
    .map(s => s.trim())
    .reduce((fin:string[], cur:string):string[] => {
      if (fin.length > 0) {
        const last = fin.pop() || '';
        // check for dangling fenced code block
        if ((last.match(/```/g) || []).length % 2 === 1) {
          // merge it with last paragraph
          return fin.concat(last.concat(cur));
        } else {
          fin.push(last);
          return fin.concat(cur);
        }
      } else {
        return fin.concat(cur);
      }
    }, [])

  return parsed;
}

export function useMarkdowns(lab: LabInformation, isFetchingLab: boolean): [string[], boolean] {
  const [markdowns, setMarkdowns] = useState<string[]>([]);
  const [isMarkdownFetching, setIsMarkdownFetching] = useState(false);

  useEffect(() => {
    if (lab?.runningInfo?.markdownUrl && !isFetchingLab) {
      setIsMarkdownFetching(true);
      const url = `${lab.runningInfo.markdownUrl}/README.md`
      axios.get(url, { withCredentials: true})
        .then((result) => {
          const markdown: string = result.data;
          const parsed:string[] = parseMarkdown(markdown)
          setMarkdowns(parsed);
          setIsMarkdownFetching(false);
        })
        .catch(() => {
          setMarkdowns([])
          setIsMarkdownFetching(false);
        });
    } else {
      setMarkdowns([]);
    }
  }, [lab?.runningInfo?.markdownUrl, isFetchingLab]);

  return [markdowns, isMarkdownFetching];
}

export function useFetchLabInformation(id: number, { workshopId, callback, preventLoading, iltCourseId }: { workshopId?: number; iltCourseId?: number; callback?: () => void; preventLoading?: boolean }): () => void {
  const dispatch = useDispatch();
  const fetch = useCallback(() => {
    dispatch(getLabInformationActions.request({ id, condition: 'Buy', workshopId, preventLoading, iltCourseId }));
    callback && callback();
  }, [id, workshopId, callback]);

  return fetch;
}

interface BuyLabOption {
  creditMethod: CreditMethod,
  workshopId?: number;
  iltCourseId?: number;
  courseId?: number;
  success?: () => void;
  onError?: (error: string) => void;
}

export function useBuyLab(id: number, { creditMethod, workshopId, courseId, iltCourseId, success, onError }: BuyLabOption): () => void {
  const dispatch = useDispatch();

  const buyLab = useCallback(() => {
    dispatch(buyLabActions.request({
      id,
      creditMethod,
      workshopId,
      iltCourseId,
      courseId,
      success,
      onError,
    }));
  }, [id, workshopId, courseId, iltCourseId, success, onError])

  return buyLab;
}

export function useTestLab(id: number, { success, onError }: { success?: () => void; onError?: (error: string) => void }): () => void {
  const dispatch = useDispatch();
  const testLab = useCallback(() => {
    dispatch(buyLabActions.request({
      id,
      test: true,
      success,
      onError,
    }))
  }, [id, success, onError]);

  return testLab;
}

export function useEndLab(id: number, callback?: () => void): () => void {
  const dispatch = useDispatch();

  const endLab = useCallback(() => {
    dispatch(endLabActions.request({
      id,
      callback,
    }))
  }, [id, callback]);

  return endLab;
}

export function useUpdateRunningLab(): (runningLab: Partial<RunningLab>) => void {
  const dispatch = useDispatch();

  const updateRunningLab = useCallback((runningLab: Partial<RunningLab>) => {
    dispatch(updateRunningLabAction(runningLab));
  }, []);

  return updateRunningLab;
}

export function useIsNavigationScrolling(): boolean {
  const [isNavigationScrolling, setIsNavigationScrolling] = useState(false);

  useEffect(() => {
    Events.scrollEvent.register('begin', () => {
      setIsNavigationScrolling(true);
    });

    Events.scrollEvent.register('end', () => {
      localStorage.setItem('labScrollY', JSON.stringify(window.scrollY))
      setIsNavigationScrolling(false);
    });

    scrollSpy.update();

    return () => {
      Events.scrollEvent.remove('begin');
      Events.scrollEvent.remove('end');
    };
  }, []);

  return isNavigationScrolling;
}

export const useSendVisitLab = (id: number): () => void => {
  const visitedLabs:number[] = JSON.parse(localStorage.getItem('visitedLabs') || '[]');
  const dispatch = useDispatch();

  return useCallback(() => {
    if (visitedLabs) {
      if (visitedLabs.indexOf(id) === -1) {
        const newVisitedCourse = [...visitedLabs, id];
        dispatch(sendVisitedLabActions.request({
          id
        }))
        localStorage.setItem('visitedLabs', JSON.stringify(newVisitedCourse));
      }
    } else {
      const newVisitedCourse = [id];
      dispatch(sendVisitedLabActions.request({
        id
      }))
      localStorage.setItem('visitedLabs', JSON.stringify(newVisitedCourse));
    }
  }, [id])
}
